import styled from 'styled-components';

export const RadioInput = styled.input.attrs({
  type: 'radio',
})`
  vertical-align: middle;
  margin-top: -2px;
`;
